export enum EventStatus {
    allTicketsRequireUnlock = 'allTicketsRequireUnlock',
    live = 'live',
    started = 'started',
    draft = 'draft',
    canceled = 'canceled',
    ended = 'ended',
    soldOut = 'soldOut',
    soldOutInTicketSelection = 'soldOutInTicketSelection',
    soldOutWithCapacityWaitlist = 'soldOutWithCapacityWaitlist',
    soldOutWithTicketReseller = 'soldOutWithTicketReseller',
    salesEnded = 'salesEnded',
    unavailable = 'unavailable',
    sold_out = 'sold_out',
    sales_ended = 'sales_ended',
}
